import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { DatasetActionContainerService } from './datasetACS';
import { RecordService } from './record.service';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import * as moment from 'moment';
import { ICartData } from './cart.service';

@Injectable()
export class TourService{

	public responseData: BehaviorSubject<any>;
	public selectedDate: any;
	public fromDate = new Date();
	public bookingForm: FormGroup;
	public going_resources: any;
	public return_resources: any;
	public show_booking_form: boolean;
	public is_first_loading: boolean;
	public trip_service_rule_type: any;

	constructor(
		public recordService: RecordService,
		public datasetACS: DatasetActionContainerService,
		private fb: FormBuilder){
			/** init responsedata */
			this.responseData = new BehaviorSubject<any>(null);
			this.show_booking_form = false;
			this.is_first_loading = true;
		}

	initForm(): void{
		this.bookingForm = this.fb.group({
			adults: new FormControl(1),
			children: new FormControl(0),
			infants: new FormControl(0),
			seniors: new FormControl(0),
			date: new FormControl(''),
			actual_trip_id: new FormControl(''),
			return_trip_id: new FormControl(''),
			optional_services: this.fb.array([]),
			optional_return_services: this.fb.array([]),
			is_family: new FormControl(false),
		});
	}

	clearResources(): void{
		const optional_services = <FormArray>this.bookingForm.get('optional_services');
		if (optional_services) optional_services.clear();
		const return_optional_services = <FormArray>this.bookingForm.get('return_optional_services');
		if (return_optional_services) return_optional_services.clear();
	}
	
	reload(changeDate?: boolean): Observable<boolean>{
		const reloaded = new Subject<boolean>();
		/** set extra params */
		this.setExtraParams(changeDate);
		// reload record with relations and additional data
		this.recordService.reload()
		.subscribe({
			next: response => {
				// set booking form variables
				this.show_booking_form = response.show_booking_form;
				this.is_first_loading = response.is_first_loading;
				// set response
				this.responseData.next(response);
				// set object
				reloaded.next(true);
				reloaded.complete();
			},
			error: respErr => {
				console.error(respErr);
				reloaded.next(false);
				reloaded.complete();
			}
		});
		return reloaded;
	}
	
	isAdult(trip_service: any): boolean {
		return trip_service.trip_service_rule && trip_service.trip_service_rule.code === 'ADT';
	}

	setExtraParams(changeDate?: boolean): void{
		const rawData = this.bookingForm.getRawValue();
		this.recordService.extraParams = rawData;
		console.log(rawData);
		this.recordService.extraParams['from_date'] = moment(this.fromDate).format('YYYY-MM-DD');
		this.recordService.extraParams['date'] = moment(new Date(this.selectedDate)).format('DD/MM/YYYY');
		this.recordService.extraParams['trip_package_id'] = this.record?.id;
		if (rawData['optional_services']){
			this.recordService.extraParams['optional_services'] = rawData['optional_services'].join(',');
		}
		if (rawData['optional_return_services']){
			this.recordService.extraParams['optional_return_services'] = rawData['optional_return_services'].join(',');
		}
		this.is_first_loading = false;
		rawData['is_first_loading'] = this.is_first_loading;
		if (changeDate){
			this.recordService.extraParams['change_date'] = true;
		}
	}

	getRawValue(): ICartData{
		const formData = this.bookingForm.getRawValue();
		const actualTrip = this.actualTrips.find(actualTrip => actualTrip.id === formData['actual_trip_id']);
		console.log(this.actualTrips);
		console.log(formData);
		console.log(actualTrip);
		formData['target'] = 'trip_packages';
		formData['trip_package_id'] = this.record.id;
		formData['display_name_item'] = this.record.description;
		formData['variation_name_item'] = actualTrip.display_name + (actualTrip.start_time ? ' (' + actualTrip.start_time + ')': '');
		formData['master_image'] = this.record.master_image;
		formData['contextual_domain_id'] = this.record.domain.id;
		formData['trips'] = [
			{
				actual_trip_id: formData['actual_trip_id'],
				meeting_point_id: null,
				optional_services: formData['optional_services'],
				//resources_pickups: []
			},
			{
				actual_trip_id: formData['return_trip_id'],
				meeting_point_id: null,
				optional_services: formData['optional_return_services'],
				//resources_pickups: []
			}
		];
		formData['participants'] = {
			adults: formData['adults'],
			children: formData['children'],
			infants: formData['infants'],
			seniors: formData['seniors']
		};

		return formData;
	}

	optonalServices(): void{
		this.going_resources = null;
		this.return_resources = null;

		if (this.bookingStatus && this.bookingStatus.packages){
			// going optional services
			const pack1 = this.bookingStatus.packages.find(el => el.actual_trip_id == this.data.going_trip);
			this.going_resources = pack1?.resources;
			// returns optional services
			const pack2 = this.bookingStatus.packages.find(el => el.actual_trip_id == this.data.return_trip);
			this.return_resources = pack2?.resources;
		}
	}

	//#region getter
	get data(): any{
		return this.responseData.value.data;
	}

	get lang(): string{
		return this.responseData.value.lang;
	}

	get record(): any{
		return this.responseData.value.data.record;
	}

	get active_language_codes(): any[]{
		return this.record.active_language_codes;
	}

	get languageContents(): any{
		return this.record.language_contents;
	}

	get bookingStatus(): any{
		return this.responseData.value.booking_status;
	}

	get actual_trips_first_available_date(): any{
		return this.responseData.value.data.actual_trips_first_available_date;
	}

	get avaliable_dates(): any{
		return this.responseData.value.data.avaliable_dates;
	}

	get actualTrips(): any[]{
		return this.responseData.value.data.actual_trips;
	}

	get returnTrips(): any{
		return this.responseData.value.data.return_trips;
	}

	get isByParticipantRuleType(): boolean{
		if (this.responseData.value.data?.trip_service_rule_type){
			return this.responseData.value.data?.trip_service_rule_type != 1;
		}

		return true;
	}

	get limit_pax_per_booking(): number{
		return this.responseData.value.data.limit_pax_per_booking;
	}

	get categories(): string[]{
		if (this.record.categories){
			return this.record.categories;
		}
		return [];
	}

	get properties(): any{
		if (this.languageContents && this.languageContents.properties){
			return this.languageContents.properties;
		}
		return null;
	}

	get price(): any{
		if (this.bookingStatus.total_price_text){
			return this.bookingStatus.total_price_text;
		}
		return 0;
	}

	get discount(): any{
		if (this.bookingStatus.total_tour_discount){
			return this.bookingStatus.total_tour_discount;
		}
		return 0;
	}

	get originalPrice(): any{
		if (this.bookingStatus.total_tour_price){
			return this.bookingStatus.total_tour_price;
		}
		return 0;
	}

	get defaultPrice(): any{
		if(this.record.actual_trips_mode === 'external') return parseFloat(this.record.properties.price.value);
		if(!this.record.trip_service_catalog_items) return null;
		const tripService = this.record.trip_service_catalog_items.filter(this.isAdult);
		if(!tripService || tripService.length === 0) return null;
		return tripService[0].price;
	}

	get isValid(): boolean{
		return this.responseData.value.valid;
	}

	get nextAvaialableTrip(): any{
		return this.responseData.value.next_available_trip;
	}

	get hasNextAvailableTrip(): boolean{
		return this.nextAvaialableTrip != null;
	}

	get hasTripServices(): boolean{
		return this.record.trip_service_catalog_items.length > 0;
	}

	get no_price_rule(): boolean{
		return this.error == 'no_price_rule';
	}

	get error(): any{
		return this.responseData.value.error;
	}
	
	get disabledPartecipantCategories(): any{
		if(!this.record.properties.disabled_participant_categories.value) return []
		return this.record.properties.disabled_participant_categories.value.split(',');
	}
	
	get familyEnabled(): boolean{
		return this.responseData.value.family && this.responseData.value.family.enabled;
	}
	
	get familyLimitADT(): any{
		if(this.familyEnabled) return {max: this.responseData.value.family.ADT_max, min: this.responseData.value.family.ADT_min};
		else return null;
	}
	get familyLimitCHD(): any{
		if(this.familyEnabled) return {max: this.responseData.value.family.CHD_max, min: this.responseData.value.family.CHD_min};
		else return null;
	}
	//#endregion getter
}
